/**
 * 将扁平数组转换为树形结构
 * @param {Array} data 扁平数组
 * @param {Object} config 配置项
 * @returns {Array} 树形结构
 */
export function buildTree(data, config = {}) {
    const {
        idKey = 'typeId',
        parentKey = 'typeParentId',
        childrenKey = 'children',
        labelKey = 'typeName',
        valueKey = 'typeId',
        rootParentId = null // 根节点的父ID
    } = config;

    // 创建映射表
    const map = {};
    data.forEach(item => {
        map[item[idKey]] = { ...item, [childrenKey]: [] };
    });

    // 组装树
    const tree = [];
    Object.values(map).forEach(item => {
        const parentId = item[parentKey];
        if (parentId === rootParentId || !map[parentId]) {
            // 根节点或父节点不存在（可能是根节点）
            tree.push(item);
        } else {
            // 添加到父节点的children中
            map[parentId][childrenKey].push(item);
        }
    });

    // 递归格式化（可选：只保留需要的字段）
    const formatTree = (nodes) => {
        return nodes.map(node => {
            const formattedNode = {
                label: node[labelKey],
                value: node[valueKey],
                id: node['id'],
            };
            if (node[childrenKey] && node[childrenKey].length > 0) {
                formattedNode[childrenKey] = formatTree(node[childrenKey]);
            }
            return formattedNode;
        });
    };

    return formatTree(tree);
}

/**
 * 深拷贝
 * @param {*} obj 
 * @param {*} hash 
 * @returns 
 */
export const deepClone = (obj, hash = new WeakMap()) => {
    // null 或 undefined 不是对象，直接返回  
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // 如果循环引用了就用 weakMap 来解决  
    if (hash.has(obj)) {
        return hash.get(obj);
    }

    let cloneObj = Array.isArray(obj) ? [] : {};
    hash.set(obj, cloneObj);

    // 递归拷贝  
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            cloneObj[key] = deepClone(obj[key], hash);
        }
    }

    return cloneObj;
}